import React from 'react';
import {
  ModuleHeader as SharedModuleHeader,
  type ModuleHeaderProps as SharedModuleHeaderProps,
} from '@cubemeet/ui';

/**
 * Web 端 ModuleHeader 桥接层
 * 
 * 负责处理 Web 端特定的逻辑，例如：
 * - 不需要处理 SafeArea insets（Web 端没有刘海屏）
 * - StatusBar 在 Web 端不适用
 */
type ModuleHeaderProps = Omit<SharedModuleHeaderProps, 'topInset'> & { noEdgePadding?: boolean };

const ModuleHeader: React.FC<ModuleHeaderProps> = (props) => {
  const { noEdgePadding, ...rest } = props as any;
  return (
    <SharedModuleHeader
      {...(rest as SharedModuleHeaderProps)}
      topInset={0} // Web 端不需要顶部安全区域
      noEdgePadding={noEdgePadding}
    />
  );
};

export default ModuleHeader;
